import React from 'react';
import Select from 'react-select';
import AdminValueContainer from '../../widgets/filters/react-select-custom-child-components/AdminValueContainer';
import { ChevronDown } from '../../widgets/filters/react-select-custom-child-components/DropdownHelpers';

interface Props {
  items: Array<{
    value: number,
    label: string,
  }>,
  onChange: (hitsPerPage: number) => void,
  currentRefinement: number,
}

const SimpleHitsPerPage: React.FC<Props> = ({
  items,
  currentRefinement,
  onChange,
}) => {
  return (
    <Select
      isClearable={false}
      aria-label="Hits per page."
      className="algolia-select btn btn-outline-light border-border-grey button-shadow text-dark-btn-txt align-items-center"
      classNamePrefix="algolia-select"
      value={{
        label: currentRefinement.toString(),
        value: currentRefinement,
      }}
      components={{
        ValueContainer: AdminValueContainer,
        DropdownIndicator: ChevronDown,
        IndicatorSeparator: () => null,
      }}
      onChange={(item) => item?.value && onChange(item.value)}
      isSearchable={false}
      options={items}
      placeholder={currentRefinement}
    />
  );
};

export default SimpleHitsPerPage;
